import { Component } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { LocationService } from '../../services/LocationService';
import { PushService } from '../../services/PushService';

export interface PermissionsOnboardingResult {
	locationAllowed: boolean;
	pushAllowed: boolean;
}

@Component({
	standalone: false,
	selector: 'permissions-onboarding',
	templateUrl: 'permissions-onboarding.component.html',
	styleUrls: ['permissions-onboarding.component.scss']
})
export class PermissionsOnboardingComponent {

	step: 1 | 2 = 1;

	private locationAllowed = false;

	constructor(
		private modalController: ModalController,
		private platform: Platform,
		private locationService: LocationService,
		private pushService: PushService) {}

	chooseLocation(allowed: boolean): void {
		this.locationAllowed = allowed;
		// Native already prompts immediately after this modal closes (app.component.ts). Web/WebKit
		// only honors the real permission dialog inside a still-live user gesture, so it has to be
		// requested right here, inside this tap - by the time app.component.ts's async chain would
		// otherwise get around to it, the gesture has expired.
		if (allowed && !this.platform.is('cordova')) {
			this.locationService.requestPermission();
		}
		this.step = 2;
	}

	choosePush(allowed: boolean): void {
		if (allowed && !this.platform.is('cordova')) {
			this.pushService.requestPermission();
		}
		const result: PermissionsOnboardingResult = { locationAllowed: this.locationAllowed, pushAllowed: allowed };
		this.modalController.dismiss(result);
	}
}
